/* aw-lead-crm.js (14 Oct 2026) — awahe.com "Book a Call" form -> Awahe CRM warm lead.
   API: POST https://api2.awahe.com/v2/warm-lead/website-lead  (CORS: https://awahe.com only, 5 req/hour/IP, JSON only, no cookies).
   First-touch attribution is read from localStorage "awAttr" (written site-wide by snippets/aw-attribution.liquid).
   Loaded by sections/aw-book-a-call.liquid. The Shopify contact form email is kept as a backup copy. */
(function () {
  'use strict';
  var API = 'https://api2.awahe.com/v2/warm-lead/website-lead';
  var PHONE = '(209) 655-0001';
  var TEL = 'tel:+12096550001';

  function byId(id) { return document.getElementById(id); }

  function e164(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return null;
  }

  function newEventId() {
    var r = Math.random().toString(36).slice(2, 8);
    while (r.length < 6) r += '0';
    return 'bc-' + Date.now() + '-' + r;
  }

  function readAttr() {
    var a = {};
    try { a = JSON.parse(localStorage.getItem('awAttr') || 'null') || {}; } catch (e) { a = {}; }
    // Fallback to the current URL if nothing was stored (storage blocked, or first page is this one).
    try {
      var p = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ttclid', 'fbclid', 'gclid'].forEach(function (k) {
        if (!a[k] && p.get(k)) a[k] = p.get(k);
      });
    } catch (e) {}
    return a;
  }

  function sha256(v) {
    if (!v || !(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(v)).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    }).catch(function () { return ''; });
  }

  // Ad pixels: one call each, all sharing the CRM eventId. Only fires pixels that exist on the page.
  function firePixels(eventId, email, phone) {
    Promise.all([sha256(String(email || '').trim().toLowerCase()), sha256(phone || '')]).then(function (h) {
      var he = h[0], hp = h[1];
      try {
        if (window.ttq && typeof window.ttq.track === 'function') {
          var idn = {};
          if (he) idn.email = he;
          if (hp) idn.phone_number = hp;
          if ((he || hp) && typeof window.ttq.identify === 'function') window.ttq.identify(idn);
          window.ttq.track('SubmitForm', {}, { event_id: eventId });
        }
      } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', {}, { eventID: eventId }); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { transaction_id: eventId }); } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'generate_lead', event_id: eventId, lead_source: 'book_a_call', user_data: { sha256_email_address: he || undefined, sha256_phone_number: hp || undefined } });
      } catch (e) {}
    });
  }

  function init() {
    var f = byId('BookCallForm');
    if (!f || f.__awCrm) return;
    if (!byId('bc-name')) return; // server-rendered thank-you state, nothing to wire
    f.__awCrm = true;

    var btn = f.querySelector('button[type="submit"]');
    var btnHtml = btn ? btn.innerHTML : '';
    var msg = f.querySelector('.awbc__msg');
    var loaded = Date.now();

    // Put the first-touch campaign into the email backup too.
    var a0 = readAttr();
    var camp = byId('bc-campaign');
    if (camp) camp.value = [a0.utm_source, a0.utm_campaign, a0.utm_content].filter(Boolean).join(' / ');

    function say(text) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
    }

    function clearErrs() {
      Array.prototype.forEach.call(f.querySelectorAll('.awbc__ferr'), function (n) { n.parentNode.removeChild(n); });
      Array.prototype.forEach.call(f.querySelectorAll('[aria-invalid="true"]'), function (n) { n.removeAttribute('aria-invalid'); });
    }

    function fieldErr(el, text) {
      if (!el) return;
      el.setAttribute('aria-invalid', 'true');
      var s = document.createElement('span');
      s.className = 'awbc__ferr';
      s.textContent = text;
      var host = el.closest('.awbc__field') || el.closest('.awbc__consent') || el.parentNode;
      host.appendChild(s);
    }

    function busy(on) {
      f.__busy = on;
      if (!btn) return;
      btn.disabled = on;
      btn.classList.toggle('is-busy', on);
      btn.innerHTML = on ? 'Sending&hellip;' : btnHtml;
    }

    function thanks() {
      f.innerHTML = '<div class="awbc__ok" role="status">' +
        '<div class="awbc__okicon" aria-hidden="true">&#10003;</div>' +
        '<h2>Request received!</h2>' +
        '<p>Thank you. An Awahe instructor will call you the same day (6 AM &ndash; 8 PM PT). Want to talk right now?</p>' +
        '<a class="awbc__btn" href="' + TEL + '">Call ' + PHONE + '</a>' +
        '</div>';
      try { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    // Backup copy to the store email via Shopify's contact form (best effort, never blocks the visitor).
    function emailBackup(fd) {
      try { fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin', keepalive: true }).catch(function () {}); } catch (e) {}
    }

    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (f.__busy) return;
      say('');
      clearErrs();

      // Spam trap: honeypot filled or submitted too fast -> pretend success, send nothing.
      var hp = byId('bc-website');
      if ((hp && hp.value) || Date.now() - loaded < 3000) { thanks(); return; }

      var nameEl = byId('bc-name'), phoneEl = byId('bc-phone'), emailEl = byId('bc-email');
      var consentEl = byId('bc-consent'), timeEl = byId('bc-time'), consentTxt = byId('bc-consent-text');
      var name = (nameEl.value || '').trim();
      var email = (emailEl.value || '').trim();
      var phone = e164(phoneEl.value);
      var bad = [];

      if (!name) { fieldErr(nameEl, 'Please enter your name.'); bad.push(nameEl); }
      if (!phone) { fieldErr(phoneEl, 'Enter a 10-digit US phone number, e.g. (209) 555-0123.'); bad.push(phoneEl); }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fieldErr(emailEl, 'Please enter a valid email.'); bad.push(emailEl); }
      if (consentEl && !consentEl.checked) { fieldErr(consentEl, 'Please tick the box so we can call or text you.'); bad.push(consentEl); }
      if (bad.length) { try { bad[0].focus(); } catch (e) {} return; }

      var a = readAttr();
      var eventId = newEventId();
      var fd = new FormData(f);
      var payload = {
        name: name,
        phone: phone,
        email: email,
        bestTime: timeEl ? timeEl.value : '',
        source: 'Website - Book a Call',
        consent: !!(consentEl && consentEl.checked),
        consentText: consentTxt ? consentTxt.textContent.replace(/\s+/g, ' ').trim() : '',
        utm: { source: a.utm_source || '', medium: a.utm_medium || '', campaign: a.utm_campaign || '', content: a.utm_content || '', term: a.utm_term || '' },
        clickIds: { ttclid: a.ttclid || '', fbclid: a.fbclid || '', gclid: a.gclid || '' },
        landingPage: a.landingPage || location.href,
        referrer: a.landingPage ? (a.referrer || '') : (document.referrer || ''),
        firstVisitAt: a.firstVisitAt || new Date().toISOString(),
        submittedAt: new Date().toISOString(),
        eventId: eventId
      };

      busy(true);
      fetch(API, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j || {} }; });
      }).then(function (res) {
        if (res.status === 200 && res.body.success) {
          emailBackup(fd);
          firePixels(eventId, email, phone);
          thanks();
          return;
        }
        busy(false);
        if (res.status === 400) {
          var m = res.body.message && String(res.body.message).length < 140 ? String(res.body.message).replace(/[.!?]?$/, '. ') : '';
          say(m + 'Please check your name, phone and email and try again.');
        } else if (res.status === 429) {
          say('You have already sent a few requests. We will call you soon, or call us now at ' + PHONE + '.');
        } else {
          emailBackup(fd);
          say('We could not send your request right now. Please call us at ' + PHONE + '.');
        }
      }).catch(function () {
        busy(false);
        emailBackup(fd);
        say('We could not send your request right now. Please call us at ' + PHONE + '.');
      });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
